<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-11-30 10:37:57
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-03-25 17:32:51
 * @FilePath: \miniproweb\src\views\DocPage\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="DocPageBody">
    <div class="docTitle">{{name}}</div>
    <div class="imgBoxList" v-show="name!='风险普查报告'">
      <div class="imgBoxListItem" v-for="item in list">
        <div class="itemTitleBox">{{item.name}}</div>
        <div>
          <img :src="item.url" alt style="width:100%" />
        </div>
      </div>
    </div>
    <van-cell
      title="测试文章"
      @click="gotoMypdf(item.url)"
      v-for="item in list"
      :label="item.extension"
      v-show="name=='风险普查报告'"
    >
      <template #title>
        <span class="custom-title">{{item.name}}</span>
      </template>
    </van-cell>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      name: "干旱"
    };
  },
  created() {
    console.log(JSON.parse(this.$route.params.id));
    this.getTypeList(JSON.parse(this.$route.params.id));
    this.name = JSON.parse(this.$route.params.id).name;
    console.log(this.name);
  },
  methods: {
    gotoMypdf(url) {
      console.log(url);
      this.$router.push({
        name: `ShowPdf`,
        params: {
          url: url
        }
      });
    },
    getTypeList(data) {
      this.$axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/fileUrl/getFileUrlInfo",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          type: data.value
        }
      }).then(res => {
        console.log(res.data);
        if (this.name == "风险普查报告") {
          this.list = res.data;
        } else {
          this.list = res.data.filter(item => item.extension == "png");
        }

        console.log(this.list);
      });
    }
  }
};
</script>

<style>
.DocPageBody {
  height: 100vh;
  width: 100vw;
  padding: 15px 0;
}
.docTitle {
  height: 50px;
  width: 100%;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
  color: rgb(0, 140, 255);
}
.imgBoxList {
  width: 100%;
}
.imgBoxListItem {
  /* height: 300px; */
  width: 100%;
  border-bottom: 1px solid black;
  /* background-color: aqua; */
  /* border: 1px solid red; */
}
.itemTitleBox {
  height: 40px;
  width: 100%;
  /* background-color: red; */
  text-align: center;
  line-height: 40px;
}
</style>